import React, { useState, useEffect } from 'react';
import { Moon, Sun, BookMarked, Loader, ChevronLeft, ChevronRight, XCircle, Download } from 'lucide-react';
import { Facebook, Twitter, Linkedin } from 'lucide-react';

// Main application component
export default function App() {
  // Constants for the app
  const bookTitle = "Root To Cure";
  const bookAuthor = "Prof. Dr. Mojibul Haque";
  const totalPages = 158;
  const sessionDuration = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

  // Hardcoded user data as per your provided list. Private key is the last 6 digits of phone number.
  const usersData = [
    { name: 'Shahnaz Siddiqa', privateKey: '586189' },
    { name: 'Matiur Rahman', privateKey: '978202' },
    { name: 'Mohammed Abu Jafar', privateKey: '235624' },
    { name: 'Shahanaj Parvin', privateKey: '919460' },
    { name: 'Omor Faruqui', privateKey: '305216' },
    { name: 'Rasheeda Muneer', privateKey: '303721' },
    { name: 'Ahmednur Mesha', privateKey: '685404' },
    { name: 'Mohammad Hasan', privateKey: '578976' },
    { name: 'Noor u ahmed', privateKey: '285962' },
    { name: 'Md Harun', privateKey: '979846' },
    { name: 'Kamal Hossain', privateKey: '104920' },
    { name: 'Omar Farooque', privateKey: '122448' },
    { name: 'Mohammad Saqi Sharif', privateKey: '200884' },
    { name: 'Yasmin Tarafder', privateKey: '507806' },
    { name: 'Kazi Shampa', privateKey: '339394' },
    { name: 'Bidushi Kabir', privateKey: '794245' },
    { name: 'Md Jahangir Alam', privateKey: '553427' },
    { name: 'Sahab Uddin', privateKey: '663307' },
    { name: 'Chandana Das', privateKey: '594951' },
    { name: 'Zillur Rahman Shaheen', privateKey: '968408' },
    { name: 'Fahmida Islam', privateKey: '650310' },
    { name: 'Maya Rahman', privateKey: '163967' },
    { name: 'Shaikh Rajbir Ahmed', privateKey: '391372' },
    { name: 'Nurul Islam', privateKey: '490663' },
    { name: 'Shilon Ahmed', privateKey: '997371' },
    { name: 'Shahan Majumdar', privateKey: '717886' },
    { name: 'Md Rashadul Alam Chy', privateKey: '717254' },
    { name: 'Mohmmad Russell', privateKey: '487143' },
    { name: 'Ak Salim', privateKey: '370564' },
    { name: 'Mohammed Chowdhury', privateKey: '328142' },
    { name: 'Fahmeda Akther', privateKey: '361769' },
    { name: 'Shanzida Mazumder', privateKey: '414537' },
    { name: 'mohammad Zakir Hossain', privateKey: '177336' },
    { name: 'Md Faruqul Islam', privateKey: '849009' },
    { name: 'Md Khalil', privateKey: '710729' },
    { name: 'Nasrin Begum', privateKey: '978665' },
    { name: 'Mona Rubina', privateKey: '803602' },
    { name: 'Mosammat Noor', privateKey: '665208' },
    { name: 'Fahmida Mausumi', privateKey: '681980' },
    { name: 'Mohamed Miah', privateKey: '224634' },
    { name: 'Tipu Sultan', privateKey: '170310' },
    { name: 'Abdul Karim', privateKey: '432445' },
    { name: 'Tasnuva Mizan', privateKey: '633707' },
    { name: 'Oli Qoza', privateKey: '976864' },
    { name: 'Khurshid Alam', privateKey: '781061' },
    { name: 'Mahabubur Rahman', privateKey: '403819' },
    { name: 'Mohammed Islam', privateKey: '173742' },
    { name: 'Abdul Kuddus', privateKey: '815951' },
    { name: 'Syed Alam', privateKey: '539292' },
    { name: 'Md Rahman', privateKey: '318698' },
    { name: 'Md. Delower Hossain', privateKey: '603357' },
    { name: 'Maksuda Akter', privateKey: '958500' },
    { name: 'monirujjaman monir mollah', privateKey: '828834' },
    { name: 'Shaila Sumi', privateKey: '645943' },
    { name: 'Nusrat Atoshi', privateKey: '385206' },
    { name: 'AKM MOHAMMAD MAHMUD UR RASHID SUMON', privateKey: '361319' },
    { name: 'Latifa Lata', privateKey: '513170' },
    { name: 'Husna Khan', privateKey: '405046' },
    { name: 'Pappu Pappu', privateKey: '062947' },
    { name: 'Nadia Akther', privateKey: '704284' },
    { name: 'Sujan Sharkar', privateKey: '972121' },
    { name: 'Azizur Rahman', privateKey: '084261' },
    { name: 'Salma Akter', privateKey: '334667' },
    { name: 'Afreen Nahar', privateKey: '782624' },
    { name: 'Aminul Haque', privateKey: '668639' },
    { name: 'Manisa Ashrafi', privateKey: '017703' },
    { name: 'Uttam Barua', privateKey: '943190' },
    { name: 'Abid Chowdhury', privateKey: '910286' },
    { name: 'Kazi Zara Delowar', privateKey: '454874' },
    { name: 'Jannatul Pervin', privateKey: '414509' },
    { name: 'Mohammed Chowdhury', privateKey: '448774' },
    { name: 'Inun Nahar', privateKey: '477769' },
    { name: 'Shamsun Parveen', privateKey: '151487' },
    { name: 'Dolli Ghosh', privateKey: '959475' },
    { name: 'Karim Fazlul', privateKey: '180558' },
    { name: 'MD Habibur Rahman', privateKey: '038889' },
    { name: 'Md Rahman', privateKey: '869836' },
    { name: 'M H Ahmead', privateKey: '001380' },
    { name: 'Khondaker Iqbal Jahangir', privateKey: '498044' },
    { name: 'Moniruzzaman', privateKey: '060801' },
    { name: 'Shariful Islam', privateKey: '504533' },
    { name: 'Mohammed Kamruzzaman', privateKey: '879616' },
    { name: 'Ashraf Safwan', privateKey: '875102' },
    { name: 'Shamima Shamama', privateKey: '54210' },
    { name: 'Mafiz Mafiza', privateKey: '068932' },
    { name: 'Aminur Rahman', privateKey: '331400' },
    { name: 'Rai Nai', privateKey: '933420' },
    { name: 'Ashraf Ullah', privateKey: '938666' },
    { name: 'Ripon Das', privateKey: '595765' },
    { name: 'Sayed Hasan', privateKey: '426342' },
    { name: 'Muhammad Rahaman', privateKey: '758813' },
    { name: 'Md Matiul Hoque', privateKey: '375833' },
    { name: 'Mina Mahmud', privateKey: '490232' },
    { name: 'mirza hafiz', privateKey: '500811' },
    { name: 'Abdul Wadud', privateKey: '093397' },
    { name: 'Bazlur Rahman Khan', privateKey: '712338' },
    { name: 'SAIF ABDULLAH', privateKey: '436532' },
    { name: 'Jamilur Khan', privateKey: '323397' },
    { name: 'Abid Alam', privateKey: '906528' },
    { name: 'A K M Emran', privateKey: '70778' },
    { name: 'Mohammad Mijanur Rahman', privateKey: '367928' },
    { name: 'Md Syful Islam', privateKey: '427852' },
    { name: 'Masuda Akter', privateKey: '208370' },
    { name: 'Morshadul Alam', privateKey: '231718' },
    { name: 'Mohammed Shamim', privateKey: '787188' },
    { name: 'Nazrul Islam Chowdhury', privateKey: '09958' },
    { name: 'Sharmin Sarna', privateKey: '196943' },
    { name: 'Jahanara akter', privateKey: '622562' },
    { name: 'Khairon Lira', privateKey: '374565' },
    { name: 'শাপলা লিলি', privateKey: '998835' },
    { name: 'Mohammad Altaf Hussain', privateKey: '411806' },
    { name: 'Kazi Naser', privateKey: '549683' },
    { name: 'Abdul k Howladar', privateKey: '979862' },
    { name: 'Md Atiqur Rahman', privateKey: '106820' },
    { name: 'Tasmeema Tabassum', privateKey: '053130' },
    { name: 'Mohammed Anowar', privateKey: '506174' },
    { name: 'Amirul Aziz', privateKey: '074578' },
    { name: 'Md Rubel', privateKey: '172117' },
    { name: 'Mohammad Amin', privateKey: '484472' },
    { name: 'Liton Paul', privateKey: '221466' },
    { name: 'Nazim Sarker', privateKey: '032900' },
    { name: 'Abdullah al Mamun', privateKey: '290448' },
    { name: 'Mohammed Jakaria', privateKey: '256098' },
    { name: 'Mohammed Haque', privateKey: '175948' },
    { name: 'Md Afsar Uddin', privateKey: '648121' },
    { name: 'Sanah Ullah', privateKey: '339162' },
    { name: 'Saroj Das', privateKey: '331296' },
    { name: 'Md a khandaker', privateKey: '051166' },
    { name: 'Monotosh Roy', privateKey: '449626' },
    { name: 'Mohammad Rahman', privateKey: '327613' },
    { name: 'Ruhul Amin', privateKey: '220390' },
    { name: 'Roxana Naureen Huq', privateKey: '588262' },
    { name: 'Mohammed Murad', privateKey: '031887' },
    { name: 'Md Golam Rabbani', privateKey: '619791' },
    { name: 'Saiful Islam', privateKey: '887098' },
    { name: 'Sharif Z Chowdhury', privateKey: '027374' },
    { name: 'Mohammed Quadery', privateKey: '855027' },
    { name: 'Noor', privateKey: '35905' },
    { name: 'Kamruzzaman Uzzal', privateKey: '869025' },
    { name: 'Hena Begum', privateKey: '939765' },
    { name: 'Md Jahangir Alam', privateKey: '281266' },
    { name: 'Jamie Rahman', privateKey: '886204' },
    { name: 'Shahadiar Habib', privateKey: '624083' },
    { name: 'Shah ASM Mahfujul Islam', privateKey: '993901' },
    { name: 'Afrina Sultana', privateKey: '748351' },
    { name: 'Md Nasir Uddin', privateKey: '997556' },
    { name: 'Abu Khaliquzzaman', privateKey: '754237' },
    { name: 'Mohammad Rezaul Islam Chowdhury', privateKey: '469478' },
    { name: 'Md Zahirul Islam', privateKey: '859328' },
    { name: 'Farhana Akhter', privateKey: '174570' },
    { name: 'Sazzad Islam', privateKey: '135758' },
    { name: 'Roksana begum', privateKey: '397534' },
    { name: 'Tasmin Tamanna', privateKey: '384989' },
    { name: 'Ruhul Morshed', privateKey: '433976' },
    { name: 'Shah Zahurul Islam Hamza', privateKey: '082545' },
    { name: 'Mohammed S. Uddin', privateKey: '009227' },
    { name: 'Lima Sharif', privateKey: '203066' },
    { name: 'Nadira Akter Farzana', privateKey: '644221' },
    { name: 'Sayed Md Shakhawat Hossain', privateKey: '240459' },
    { name: 'Sudip Barua', privateKey: '809403' },
    { name: 'Maruf Raihan', privateKey: '610710' },
    { name: 'Sanjida Runa', privateKey: '782880' },
    { name: 'Shahin Pabna NY', privateKey: '864577' },
    { name: 'Amzad Hossain', privateKey: '356063' },
    { name: 'Md islam', privateKey: '165347' },
    { name: 'Shakhawat Hossain', privateKey: '572677' },
    { name: 'Mohammad Islam', privateKey: '406124' },
    { name: 'Hasan Sharif', privateKey: '590438' },
    { name: 'Supreem Nahar Shawon', privateKey: '699116' },
    { name: 'Main Uddin', privateKey: '402066' },
    { name: 'Aarfan Zenith', privateKey: '761499' },
    { name: 'Shakti Bhowmik', privateKey: '846307' },
    { name: 'Mir Taslima', privateKey: '369042' },
    { name: 'Shaila Ahmed', privateKey: '831166' },
    { name: 'Abdul Kuddus', privateKey: '052735' },
    { name: 'Hasu NY', privateKey: '313635' },
    { name: 'Hafizur Rahman', privateKey: '694995' },
    { name: 'Chowdhury Ahmed Reja', privateKey: '358716' },
    { name: 'Meshba Bhuiyan', privateKey: '947882' },
    { name: 'Mohammed Foyshal', privateKey: '487710' },
    { name: 'Shumie Haque', privateKey: '874859' },
    { name: 'Md A Rahman', privateKey: '787843' },
    { name: 'Shahid Ullah', privateKey: '077001' },
    { name: 'nasir ahmed', privateKey: '352406' },
    { name: 'Sk Ishita', privateKey: '339363' },
    { name: 'Ariful Quadery', privateKey: '027508' },
    { name: 'Mohammad Billal Hossain', privateKey: '679296' },
    { name: 'Saiful Islam', privateKey: '996877' },
    { name: 'Mohammed Malik', privateKey: '334588' },
    { name: 'Shamima Akter', privateKey: '133534' },
    { name: 'Saidur Rahman Majumder', privateKey: '00193' },
    { name: 'Muhammad Abdur Rabb', privateKey: '078656' },
    { name: 'Mannan Hossain', privateKey: '690070' },
    { name: 'Maleka Shahid', privateKey: '003014' },
    { name: 'Mojahid Islan', privateKey: '873595' },
    { name: 'Dilruba Quazi', privateKey: '126677' },
    { name: 'Md M Hoque', privateKey: '693998' },
    { name: 'Anwar Hossain', privateKey: '134822' },
    { name: 'Rafiqur Rashid', privateKey: '003241' },
    { name: 'Noor Naaz Hossain', privateKey: '002282' },
    { name: 'Jeeps Parvin', privateKey: '094604' },
    { name: 'Rehana Begum', privateKey: '142655' },
    { name: 'Ahmed shohel', privateKey: '079513' },
    { name: 'Sharmin Nahar', privateKey: '839172' },
    { name: 'Gazi Towhid', privateKey: '689558' },
    { name: 'M A Basher', privateKey: '545772' },
    { name: 'Md Mizanur Rahman', privateKey: '644075' },
    { name: 'Lima Alam', privateKey: '612638' },
    { name: 'Ahmed', privateKey: '930000' },
    { name: 'Sultan Shubha', privateKey: '870610' },
    { name: 'Mohammad Ziaul Hoque', privateKey: '647986' },
    { name: 'Sujan Saha', privateKey: '419376' },
    { name: 'Khurshid Alom', privateKey: '318269' },
    { name: 'Krishna Saha', privateKey: '209063' },
    { name: 'Abu Sayem', privateKey: '831258' },
    { name: 'Abul Kasham', privateKey: '092946' },
    { name: 'Shah Mohammed Badruzzaman', privateKey: '331922' },
    { name: 'Mahbub Rahman', privateKey: '922568' },
    { name: 'Aminul Islam', privateKey: '493096' },
    { name: 'Mohammed Hossain', privateKey: '539776' },
    { name: 'Akter alam', privateKey: '028549' },
    { name: 'Rahima Khatun', privateKey: '886920' },
    { name: 'Md Jabbar', privateKey: '216269' },
    { name: 'Jahirul Haque', privateKey: '995779' },
    { name: 'Mahbub Alam', privateKey: '789062' },
    { name: 'Mohammad Z. Haque', privateKey: '587150' },
    { name: 'Showkat Azad', privateKey: '864237' },
    { name: 'Mashiur Khan', privateKey: '745034' },
    { name: 'Mushtaque Ahmed Babul', privateKey: '256320' },
    { name: 'Fatema Ripa', privateKey: '550077' },
    { name: 'Muns Ahmad', privateKey: '751686' },
    { name: 'Muhammad Jamali', privateKey: '189883' },
    { name: 'Ahsan Qazi', privateKey: '445787' },
    { name: 'Shaheena Reza', privateKey: '790445' },
    { name: 'Nurul Islam', privateKey: '571933' },
    { name: 'Hasan Rahman', privateKey: '333273' },
    { name: 'Md Yeasin Ahammad', privateKey: '185120' },
    { name: 'Mohammad Mujibur Rahman', privateKey: '629949' },
    { name: 'Syed Mufazzal Sayem', privateKey: '147935' },
    { name: 'Md Forkan Chowdhury', privateKey: '512996' },
    { name: 'Md Helal', privateKey: '17825' },
    { name: 'Al Makid Billah', privateKey: '780050' },
    { name: 'Nl Momin', privateKey: '141201' },
    { name: 'Hossen Aktar', privateKey: '828107' },
    { name: 'Shameem G Khan', privateKey: '791433' },
    { name: 'Mamun Chowdhury', privateKey: '829918' },
    { name: 'Liton Chowdhury', privateKey: '421396' },
    { name: 'Nurul Hassan', privateKey: '693973' },
    { name: 'Alam Ara Begum', privateKey: '060208' },
    { name: 'Nazmul Huq', privateKey: '781396' },
    { name: 'Mohammad Zunaid', privateKey: '337298' },
    { name: 'Ratan Akash', privateKey: '67918' },
    { name: 'Ahmed Faiyaz', privateKey: '443637' },
    { name: 'Mohammad Khan', privateKey: '507675' },
    { name: 'Salina Afroza', privateKey: '039604' },
    { name: 'Abdul Howlader', privateKey: '473673' },
    { name: 'Mohammad M Sujon', privateKey: '495590' },
    { name: 'Md Maruf Hossain', privateKey: '64243' },
    { name: 'Abdul Sikder', privateKey: '131658' },
    { name: 'Borhan Uddin', privateKey: '291528' },
    { name: 'A.T. M. Farid', privateKey: '791267' },
    { name: 'Muhammad Manjurul Karim', privateKey: '756095' },
    { name: 'Shahin Ahmed', privateKey: '852350' },
    { name: 'Shamim Khan', privateKey: '313383' },
    { name: 'Selim Islam', privateKey: '293617' },
    { name: 'Ahmadur Numan', privateKey: '307600' },
    { name: 'Shakhawat Hossen', privateKey: '069006' },
    { name: 'Mahmuda Ahmed', privateKey: '388624' },
    { name: 'Zahir Ahmed', privateKey: '595333' },
    { name: 'Muquith Choudhury', privateKey: '634985' },
    { name: 'Monika Mahbub', privateKey: '676256' },
    { name: 'Manzurul Haque', privateKey: '811825' },
    { name: 'Nnp Nahar', privateKey: '600864' },
    { name: 'rahmanzulfiqur07@gmail.com', privateKey: '33319' },
    { name: 'Rajia Sultana', privateKey: '674632' },
    { name: 'Shereen Islam', privateKey: '455929' },
    { name: 'Ruksana uddin', privateKey: '309211' },
    { name: 'Ranju Sarker', privateKey: '121887' },
    { name: 'mafoja islam', privateKey: '234662' },
    { name: 'Md Azad', privateKey: '971107' },
    { name: 'Mohamed Alamgir', privateKey: '065544' },
    { name: 'Zahid Alam', privateKey: '444346' },
    { name: 'Solaiman Solaiman', privateKey: '580348' },
    { name: 'Main Uddin/Taslima Akter.', privateKey: '020133' },
    { name: 'Mo Kabir', privateKey: '576159' },
    { name: 'MD Hasan Mamun', privateKey: '774975' },
    { name: 'Mohammad B Afrad', privateKey: '428566' },
    { name: 'Atiqul Chowdhury', privateKey: '618690' },
    { name: 'Habibur Rahman', privateKey: '283191' },
    { name: 'Rasedul Haque', privateKey: '844064' },
    { name: 'Tanvir Tanvir', privateKey: '160202' },
    { name: 'Sujan Farid', privateKey: '106726' },
    { name: 'Mostafizur Rahman', privateKey: '302557' },
    { name: 'KM Saiful', privateKey: '318669' },
    { name: 'Sujon Mahabub', privateKey: '451031' },
    { name: 'Nujhat Mahjabin', privateKey: '359355' },
    { name: 'Ishrat Kumu', privateKey: '627452' },
    { name: 'Md Mohiuddin', privateKey: '393629' },
    { name: 'Mm Romzan Ali', privateKey: '295647' },
    { name: 'Syed Mosharraf Hossain', privateKey: '764347' },
    { name: 'Anjan Mazumder', privateKey: '269498' },
    { name: 'Milon Sharif', privateKey: '832473' },
    { name: 'Abdul kader', privateKey: '958628' },
    { name: 'Shakwat Hossain', privateKey: '880651' },
    { name: 'Foysol Kobir', privateKey: '243561' },
    { name: 'Farhad Islam', privateKey: '561834' },
    { name: 'Sultan Ahmed', privateKey: '496897' },
    { name: 'Md Abu Sayed Shekh', privateKey: '996162' },
    { name: 'Faysal Chowdhury', privateKey: '098056' },
    { name: 'Mahtab Ahmed', privateKey: '393663' },
    { name: 'JASIR Kabir', privateKey: '709541' },
    { name: 'Sharder Islam', privateKey: '011602' },
    { name: 'Md Jashim Uddin', privateKey: '65889' },
    { name: 'Shakhawat Hossain', privateKey: '854204' },
    { name: 'Mohammad Islam', privateKey: '745424' },
    { name: 'Joynal Abedin', privateKey: '775541' },
    { name: 'Md Uddin', privateKey: '475721' },
    { name: 'Saleha Begum', privateKey: '036252' },
    { name: 'Abul Kashem', privateKey: '095081' },
    { name: 'Milad Ahmed', privateKey: '619253' },
    { name: 'Shahina Karim', privateKey: '952619' },
    { name: 'Anam Arafat Robi Siddique', privateKey: '145130' },
    { name: 'Mohammad Islam', privateKey: '274283' },
    { name: 'Saheen Mostafa', privateKey: '097381' },
    { name: 'Alok Roy', privateKey: '223009' },
    { name: 'Md Azad', privateKey: '368707' },
    { name: 'Mau Azizur Rahaman', privateKey: '35612' },
    { name: 'Masudul Hasan', privateKey: '965818' },
    { name: 'Abu Azeema', privateKey: '106210' },
    { name: 'Mahmuda Chowdhury', privateKey: '100112' },
    { name: 'Abdul Aziz Chowdhury', privateKey: '969251' },
    { name: 'Md Mostafa Masum', privateKey: '915006' },
    { name: 'Sayed Ahamed', privateKey: '731576' },
    { name: 'Mohammad Shafiul Alam', privateKey: '780366' },
    { name: 'Anayet Ullah', privateKey: '475235' },
    { name: 'Abdullah Al Mahir', privateKey: '321043' },
    { name: 'md uddin', privateKey: '202602' },
    { name: 'Lipi Kamrun', privateKey: '504207' },
    { name: 'Rafik Ullah', privateKey: '889935' },
    { name: 'Atika Begum', privateKey: '677841' },
    { name: 'Ferdous Chowdhury', privateKey: '009212' },
    { name: 'Muhammed Ali Babu', privateKey: '764028' },
    { name: 'Sazada Begum', privateKey: '307903' },
    { name: 'Dalia Sarwar', privateKey: '247222' },
    { name: 'Farzana Mohona', privateKey: '633249' },
    { name: 'Faisal Mahmudul Hasan', privateKey: '406596' },
    { name: 'Tofazzal Hossain', privateKey: '080030' },
    { name: 'Shipra mondol', privateKey: '887664' },
    { name: 'Asma Sahin', privateKey: '493497' },
    { name: 'Sovon Jikrul Hasan', privateKey: '658381' },
    { name: 'Azmal Khan', privateKey: '406269' },
    { name: 'Mohammad Nurul Huda Mazumder', privateKey: '721304' },
    { name: 'Nurul Haque', privateKey: '366610' },
    { name: 'Tofael ahamed', privateKey: '752610' },
    { name: 'Sabina Shampa', privateKey: '21617' },
    { name: 'Ibrahim Bin Hashem', privateKey: '413477' },
    { name: 'Mohammad N Gony', privateKey: '357194' },
    { name: 'Mohammed Khan', privateKey: '646335' },
    { name: 'Mohammad Muslim Chowdhury', privateKey: '125983' },
    { name: 'S.m. Tamim Hossain', privateKey: '766255' },
    { name: 'Md Najmul Hasan', privateKey: '731248' },
    { name: 'Mohammad Hoque', privateKey: '200409' },
    { name: 'Md Aminul Hoque Tushar', privateKey: '672568' },
    { name: 'Tasnia wadud chowdhury', privateKey: '742259' },
    { name: 'Taslima Akhter', privateKey: '716051' },
    { name: 'MD Mamunor Rashid', privateKey: '186132' },
    { name: 'Anzar Karim', privateKey: '888888' },
    { name: 'Aminul Chowdhury', privateKey: '014544' },
    { name: 'Esmat Jahan Popy', privateKey: '563271' },
    { name: 'Taslim Rouf', privateKey: '830101' },
    { name: 'Tania Rahman', privateKey: '796032' },
    { name: 'M Aziz Hero', privateKey: '134209' },
    { name: 'Md Abdul Wodud', privateKey: '932152' },
    { name: 'Ataul Hoq', privateKey: '226190' },
    { name: 'Md Chowdhury', privateKey: '925648' },
    { name: 'Naznin Sultana', privateKey: '558540' },
    { name: 'Zaman Dakua', privateKey: '963146' },
    { name: 'Mamun Rashid', privateKey: '926499' },
    { name: 'Mohammad Basher', privateKey: '379746' },
    { name: 'Pushirul Islam', privateKey: '475269' },
    { name: 'Mohammad Alim', privateKey: '054318' },
    { name: 'Muhammad Abul Quasim', privateKey: '098479' },
    { name: 'Yousuf Rahim', privateKey: '004484' },
    { name: 'Syed Haque', privateKey: '008470' },
    { name: 'Kamrun Naher', privateKey: '426036' },
    { name: 'Kamrul Islam', privateKey: '929351' },
    { name: 'Md Abdullah Al baki', privateKey: '338182' },
    { name: 'Md Rahaman', privateKey: '698900' },
    { name: 'Chandan Kumar Sarker', privateKey: '678077' },
    { name: 'H M Sayed Ahmed', privateKey: '457786' },
    { name: 'Shafi Ullah', privateKey: '001955' },
    { name: 'Nurjahan Aktar', privateKey: '721778' },
    { name: 'Smk Iqbal', privateKey: '003631' },
    { name: 'Rahim', privateKey: '667079' },
    { name: 'Quazi Sadiquer Rahman', privateKey: '132042' },
    { name: 'Masuqur Rahman', privateKey: '616603' },
    { name: 'Prema', privateKey: '338400' },
    { name: 'Md. Abdul Wadud', privateKey: '09514' },
    { name: 'Mahidul Dewan', privateKey: '454237' },
    { name: 'Baten', privateKey: '159422' },
    { name: 'Aftab Uddin', privateKey: '211655' },
    { name: 'Mamun Abdullah', privateKey: '854494' },
    { name: 'Mohammad Romzan Ali', privateKey: '962643' },
    { name: 'Ragubir Dharmen', privateKey: '484292' },
    { name: 'Mohammad Karim', privateKey: '172752' },
    { name: 'Md Mazdakur Rahman', privateKey: '969803' },
    { name: 'Md Sayem Miah', privateKey: '818443' },
    { name: 'Mohammed Siddique', privateKey: '668720' },
    { name: 'Mohammad Shahinoor Alam Siddique', privateKey: '144013' },
    { name: 'Jusnaara Begum', privateKey: '571335' },
    { name: 'morjina khatun', privateKey: '69804' },
    { name: 'Rofiqul Islam', privateKey: '53907' },
    { name: 'Rezaur Rahman', privateKey: '621760' },
    { name: 'Muhammad Mijanur Rahman', privateKey: '397342' },
    { name: 'Niva Jahan', privateKey: '134655' },
    { name: 'Syed R A Rashed', privateKey: '045950' },
    { name: 'MH Hasan', privateKey: '349130' },
    { name: 'M Sarwar', privateKey: '936442' },
    { name: 'Naznin Nahar Fancy', privateKey: '144349' },
    { name: 'Salim Zahid', privateKey: '284440' },
    { name: 'Md Selim', privateKey: '473718' },
    { name: 'Umme Ruman', privateKey: '607762' },
    { name: 'Marina Akter', privateKey: '352198' },
    { name: 'Shoma Jalal', privateKey: '218403' },
    { name: 'Mahmudul Hasan Mishu', privateKey: '366194' },
    { name: 'Rukon Uddin', privateKey: '739680' },
    { name: 'Mohammad Jowel', privateKey: '896890' },
    { name: 'Mohammed Rahim', privateKey: '035190' },
    { name: 'Jacky', privateKey: '111333' },
    { name: 'Masum Hossain', privateKey: '688543' },
    { name: 'Anna Ashar', privateKey: '151610' },
    { name: 'Lutfar Rahman', privateKey: '137651' },
    { name: 'Shamima Yasmin', privateKey: '371886' },
    { name: 'Hasin Ishrak', privateKey: '943250' },
    { name: 'Sazeda Chowdhury', privateKey: '660803' },
    { name: 'Farida Yasmin', privateKey: '449465' },
    { name: 'Nasima Sultana', privateKey: '170839' },
    { name: 'Mohammad A Alam', privateKey: '916688' },
    { name: 'Shahenur Rahaman', privateKey: '533014' },
    { name: 'Rakib Uddin', privateKey: '011055' },
    { name: 'Al sabbir Saimon', privateKey: '716259' },
    { name: 'Bahar Chowdhury', privateKey: '674638' },
    { name: 'Sayeed Kazi', privateKey: '173475' },
    { name: 'Mohammad Hossain', privateKey: '939338' },
    { name: 'Nazir Ahmed', privateKey: '574489' },
    { name: 'MD Sattar', privateKey: '675419' },
    { name: 'Farhad Rizwan', privateKey: '643643' },
    { name: 'Md Hossain', privateKey: '979175' },
    { name: 'Afzalur Rahman', privateKey: '054386' },
    { name: 'Syeda Kabir', privateKey: '919775' },
    { name: 'Hazira Akbor', privateKey: '182306' },
    { name: 'Ansarul Islam', privateKey: '907924' },
    { name: 'Shaiful Islam', privateKey: '864808' },
    { name: 'Bepery Arif', privateKey: '406189' },
    { name: 'Dulal Uddin', privateKey: '661533' },
    { name: 'Abdul Auwal', privateKey: '407481' },
    { name: 'Sufia Chaudhury', privateKey: '821444' },
    { name: 'Muhibur Rahman - Muhid', privateKey: '982432' },
    { name: 'Jahangir Chowdhury', privateKey: '606190' },
    { name: 'Jahir Ul Haque', privateKey: '724577' },
    { name: 'Farid Sheik', privateKey: '492275' },
    { name: 'Besak Shikder', privateKey: '994557' },
    { name: 'Pervez Khan', privateKey: '999842' },
    { name: 'Abdul Baten', privateKey: '192519' },
    { name: 'আবুল কাশেম সরকার', privateKey: '642957' },
    { name: 'Marzabin Subhan', privateKey: '575831' },
    { name: 'Helal Uddin', privateKey: '654978' },
    { name: 'Nurun Nahar Khan', privateKey: '597292' },
    { name: 'Maksuda Khanam', privateKey: '619656' },
    { name: 'Syed Mamun', privateKey: '444678' },
    { name: 'Saiful Islam', privateKey: '970679' },
    { name: 'فتاة سحابة', privateKey: '085745' },
    { name: 'Mohammad Musa', privateKey: '894631' },
    { name: 'Nayem Faizullah', privateKey: '444133' },
    { name: 'Md Idris Ali', privateKey: '859893' },
    { name: 'Farida Parvin', privateKey: '108286' },
    { name: 'Alamgir Kabir', privateKey: '543727' },
    { name: 'Md Moin Chowdhury', privateKey: '818862' },
    { name: 'Md Amirul Islam', privateKey: '492486' },
    { name: 'Mohiul islam', privateKey: '676430' },
    { name: 'Mohammad Islam', privateKey: '577571' },
    { name: 'Farida Sheerin Khan', privateKey: '026414' },
    { name: 'Syed Shamim', privateKey: '324175' },
    { name: 'Parvin Chowdhury', privateKey: '982432' },
    { name: 'Momtaz Begum', privateKey: '65717' },
    { name: 'Rasel Cho', privateKey: '494928' },
    { name: 'Faruk', privateKey: '995839' },
    { name: 'Jobayer Hossain', privateKey: '176490' },
    { name: 'Koyes Ahad', privateKey: '952715' },
    { name: 'Hussain Ahmed', privateKey: '487076' },
    { name: 'Mohiuddin Shekh', privateKey: '422475' },
    { name: 'Umma Salma', privateKey: '284184' },
    { name: 'Abul Nasher Ali Ahmed', privateKey: '015174' },
    { name: 'Mohammad Rahaman', privateKey: '328610' },
    { name: 'Masud Reza', privateKey: '275484' },
    { name: 'Hakimur Rahman Khan', privateKey: '987080' },
    { name: 'Parveen Shahedaa', privateKey: '835465' },
    { name: 'Abdullah Al Mamun', privateKey: '730462' },
    { name: 'Md Shahid ullah', privateKey: '923957' },
    { name: 'Fahad Bin Aziz', privateKey: '684033' },
    { name: 'Mohammed Saleh', privateKey: '079365' },
    { name: 'Mohammed Rahman', privateKey: '396948' },
    { name: 'Nargis Ahmed', privateKey: '338974' },
    { name: 'Noyon Noyon', privateKey: '658284' },
    { name: 'Nasrin Jahan', privateKey: '68735' },
    { name: 'Jahangir Alam', privateKey: '621539' },
    { name: 'md Anom', privateKey: '004069' },
    { name: 'Md Z Hasan', privateKey: '768678' },
    { name: 'Razia Chowdhury', privateKey: '697777' },
    { name: 'Nasreen Khanam', privateKey: '205915' },
    { name: 'Mohammed N. Haq', privateKey: '572727' },
    { name: 'Jalal Shakho', privateKey: '705074' },
    { name: 'Bashir Ahmed', privateKey: '333908' },
    { name: 'Lina Jahan', privateKey: '612521' },
    { name: 'Monowar Ahmed', privateKey: '415702' },
    { name: 'Minara Khatun Keya', privateKey: '765156' },
    { name: 'Shoheli Hossain', privateKey: '370990' },
    { name: 'Md Khalequzzaman', privateKey: '560388' },
    { name: 'Raju Rahaman', privateKey: '357170' },
    { name: 'Helal Uddin', privateKey: '899702' },
    { name: 'Kamal Hossain', privateKey: '054982' },
    { name: 'Shaikh Rafiul Muntakim', privateKey: '532384' },
    { name: 'Alo Chowdhury', privateKey: '568790' },
    { name: 'Soheb Mohammed', privateKey: '276533' },
    { name: 'Shahanaz Brown', privateKey: '152270' },
    { name: 'Mizanur Rahman', privateKey: '885279' },
    { name: 'Mohammad Rafiqul Islam', privateKey: '159081' },
    { name: 'Biplob Gupta', privateKey: '49561' },
    { name: 'Mamun Reza', privateKey: '645812' },
    { name: 'Mohamed Rashiduzzaman', privateKey: '174629' },
    { name: 'Hashmat Ara', privateKey: '729808' },
    { name: 'Ayesha Akter', privateKey: '694956' },
    { name: 'Mohammad Moniruzzaman', privateKey: '289192' },
    { name: 'Mohammed Shamsuddin', privateKey: '949043' },
    { name: 'Kurban Sikder', privateKey: '216542' },
    { name: 'Shawon Mredol', privateKey: '643692' },
    { name: 'Md F Islam', privateKey: '366830' },
    { name: 'Exact Megha', privateKey: '729354' },
    { name: 'Fahim Abdullah', privateKey: '505746' },
    { name: 'Abm Z. Islam', privateKey: '380008' },
    { name: 'Khabiruddin Bhuiyan', privateKey: '371794' },
    { name: 'Md Akhteruzzaman Bhuiyan', privateKey: '659324' },
    { name: 'Md Shajed', privateKey: '447507' },
    { name: 'Ibrahim Syed', privateKey: '712933' },
    { name: 'Mathias Rozario', privateKey: '417311' },
    { name: 'Dilruba Bilkis', privateKey: '137280' },
    { name: 'MD Shafiqul A Khandokar', privateKey: '94300' },
    { name: 'Jubieda Tasneem', privateKey: '644261' },
    { name: 'Mustafa Alam', privateKey: '539650' },
    { name: 'Sadek Lipon', privateKey: '461728' },
    { name: 'Amran Khan', privateKey: '327262' },
    { name: 'Md Ezharul Haq', privateKey: '379750' },
    { name: 'Tofazzal hossain', privateKey: '151306' },
    { name: 'Husna Rahman', privateKey: '799706' },
    { name: 'Nasima Rahman', privateKey: '703370' },
    { name: 'Mahmudul Hasan', privateKey: '195215' },
    { name: 'Jamal Uddin', privateKey: '476972' },
    { name: 'Rehana Amin', privateKey: '399270' },
    { name: 'Farhana Yesmin', privateKey: '397800' },
    { name: 'Mahajabin Ahmed', privateKey: '067776' },
    { name: 'Shahadat Suhrawardy', privateKey: '560806' },
    { name: 'Zahura Doll', privateKey: '314710' },
    { name: 'Layes A Minu', privateKey: '626250' },
    { name: 'Sayed Mustakim', privateKey: '137060' },
    { name: 'Md Nazir Hossain', privateKey: '981523' },
    { name: 'Kazi Samsul Baten', privateKey: '812005' },
    { name: 'Nurul Azim', privateKey: '513748' },
    { name: 'Md Idlam', privateKey: '362179' },
    { name: 'Maidul Islam', privateKey: '521293' },
    { name: 'Salma Akther', privateKey: '736125' },
    { name: 'Shanta Khan', privateKey: '298133' },
    { name: 'Tazmina Akter', privateKey: '440549' },
    { name: 'Mohammad M Zaman', privateKey: '431112' },
    { name: 'Mohammed Jamil', privateKey: '598756' },
    { name: 'Luna Khatun', privateKey: '049102' },
    { name: 'Abu M Hossain', privateKey: '736367' },
    { name: 'Mohammed Patwary', privateKey: '039000' },
    { name: 'Roksana Begum', privateKey: '397534' },
    { name: 'Faruk Yeasin', privateKey: '032502' },
    { name: 'Aftab Ahmed', privateKey: '655472' },
    { name: 'MD Mostofa', privateKey: '536555' },
    { name: 'Shah Mamun', privateKey: '808095' },
    { name: 'Shamaun Kabir', privateKey: '064096' },
    { name: 'Antu Barman', privateKey: '407674' },
    { name: 'Mohammed Sarker', privateKey: '101418' },
    { name: 'Golam ahia chowdhury', privateKey: '249481' },
    { name: 'Mohammed Ahad', privateKey: '349224' },
    { name: 'Anwar Hossain', privateKey: '335307' },
    { name: 'Mohammad Kalam', privateKey: '978842' },
    { name: 'Aafroza Akhter', privateKey: '266099' },
    { name: 'Bark Qazi', privateKey: '599736' },
    { name: 'Shahnaz Ali', privateKey: '345226' },
    { name: 'S M Sayeed Mahmood', privateKey: '188572' },
    { name: 'MOHAMMAD HOSSAIN', privateKey: '478797' },
    { name: 'Najmun Begum', privateKey: '950058' },
    { name: 'Raveya Begum Lutf', privateKey: '524258' },
    { name: 'MSI', privateKey: '551374' },
    { name: 'Mehbuba Islam', privateKey: '528216' },
    { name: 'Syeda Arufa', privateKey: '746871' },
    { name: 'Mohammad Ali', privateKey: '781116' },
    { name: 'Saif mahmuf', privateKey: '152751' },
    { name: 'Shofiul Haque Shetu', privateKey: '536444' },
    { name: 'Shikha Elias', privateKey: '983669' },
    { name: 'Elora Papry', privateKey: '431918' },
    { name: 'Rashid Tipu', privateKey: '139919' },
    { name: 'Omar Faruk', privateKey: '572376' },
    { name: 'Ashiqur Rahman Ashiq', privateKey: '806657' },
    { name: 'Mohammed Abdul Mannan', privateKey: '058480' },
    { name: 'Oishi Rahman', privateKey: '574218' },
    { name: 'DrZahirul Alam', privateKey: '508959' },
    { name: 'Moktader Mowla', privateKey: '551693' },
    { name: 'Imran Mollick', privateKey: '761378' },
    { name: 'Yasmin Pinky', privateKey: '595604' },
    { name: 'N', privateKey: '367313' },
    { name: 'Mohammed Malik', privateKey: '766762' },
    { name: 'Mohammed Morshed', privateKey: '086437' },
    { name: 'Bdsh Scout', privateKey: '273843' },
    { name: 'Shahana Begum', privateKey: '787366' },
    { name: 'Shamsul Alam Jony', privateKey: '419675' },
    { name: 'Abu Rahaman Jewel', privateKey: '680954' },
    { name: 'Helen Wadud', privateKey: '098320' },
    { name: 'Ruhul Amin', privateKey: '565868' },
    { name: 'MD Hossain', privateKey: '315408' },
    { name: 'Abdul Motaleb', privateKey: '716288' },
    { name: 'Mohd Khan', privateKey: '337210' },
    { name: 'Luna Sultana', privateKey: '854395' },
    { name: 'S A M Amirul Alam', privateKey: '541207' },
    { name: 'Bellal Hossain', privateKey: '209025' },
    { name: 'islam', privateKey: '055200' },
    { name: 'Delwer Hossain', privateKey: '582478' },
    { name: 'Suraya aktet', privateKey: '695121' },
    { name: 'HaBiba Popy', privateKey: '386088' },
    { name: 'Anirban Ahmed', privateKey: '948333' },
    { name: 'Khaleda ahmed', privateKey: '356227' },
    { name: 'Tofazzol Hossen', privateKey: '591237' },
    // New data
    { name: 'Nazim', privateKey: '032900' },
    { name: 'Liton Paul', privateKey: '221466' },
    { name: 'MD A Rahman', privateKey: '106820' },
    { name: 'Masuda Akter', privateKey: '208370' },
    { name: 'A K M Emran', privateKey: '570778' },
    { name: 'Md Syful Islam', privateKey: '427852' },
    { name: 'Mina Mhamud', privateKey: '490232' },
    { name: 'Muhammad Rahaman', privateKey: '758813' },
    { name: 'Dipale Akter', privateKey: '337816' },
    { name: 'Naima', privateKey: '933420' },
    { name: 'md ashraf', privateKey: '875102' },
    { name: 'Shariful islam', privateKey: '504533' },
    { name: 'M H Ahmead', privateKey: '001380' },
    { name: 'Nayeem', privateKey: '066468' },
    { name: 'Abdur Razzk', privateKey: '903613' },
    { name: 'MD Azizur Rahman', privateKey: '084261' },
    { name: 'Jubieda Tasneem', privateKey: '644261' },
    { name: 'Latifa lata', privateKey: '513170' },
    { name: 'Ridita Tasin', privateKey: '741195' },
    { name: 'Zaima Kabir', privateKey: '243229' },
    { name: 'Rikhana Khanam', privateKey: '243526' },
    { name: 'Humayun Kabir', privateKey: '829416' },
    { name: 'Shaila sumi', privateKey: '645943' },
    { name: 'Halima Opi', privateKey: '527279' },
    { name: 'Md Mashiur Rahman', privateKey: '318698' },
    { name: 'Tasnuva Mizan', privateKey: '633707' },
    { name: 'Mohammed tipu sultan', privateKey: '441214' },
    { name: 'Md Ibrahim Khalil', privateKey: '710729' },
    { name: 'Mohammad Zakir Hossain', privateKey: '177336' },
    { name: 'ABUL KALAM salim', privateKey: '370564' },
    { name: 'Bibi joynab', privateKey: '096474' },
    { name: 'Mohammad', privateKey: '578976' },
    { name: 'Omor', privateKey: '305216' },
    { name: 'Mohammed Abu Jafar', privateKey: '235624' },
    { name: 'Md a khandaker', privateKey: '051166' },
    { name: 'Shajmen Begum', privateKey: '040892' },
    { name: 'Mohammad m Rahman', privateKey: '327613' },
    { name: 'Md Golam Rabbani', privateKey: '619791' },
    { name: 'Saiful Islam', privateKey: '887098' },
    { name: 'Mst Noorzahan', privateKey: '176079' },
    { name: 'Mohammed M Quadery', privateKey: '855027' },
    { name: 'Md Jahangir Alam', privateKey: '281266' },
    { name: 'Afrina sultana', privateKey: '468653' },
    { name: 'Mohammad Rezaul Islam Chowdhury', privateKey: '469478' },
    { name: 'Roksana begum', privateKey: '397534' },
    { name: 'Musammat Akter', privateKey: '46421' },
    { name: 'Maruf', privateKey: '610710' },
    { name: 'Mohammad shafiqul Islam', privateKey: '406124' },
    { name: 'Md Idris Ali', privateKey: '859893' },
    { name: 'Mutasim', privateKey: '935847' },
    { name: 'Rakib Hossen', privateKey: '25846' },
    { name: 'Mir Akter', privateKey: '369042' },
    { name: 'Ferdous Ara', privateKey: '951544' },
    { name: 'MG Ahmed', privateKey: '313635' },
    { name: 'Shahin', privateKey: '53016' },
    { name: 'NASIR UDDIN AHMED', privateKey: '352406' },
    { name: 'Muhammad Monzurul Alam', privateKey: '744219' },
    { name: 'Masudur Rahman', privateKey: '81965' },
    { name: 'SAIDUR RAHMAN MAJUMDER', privateKey: '00193' },
    { name: 'Md Limon Hossain', privateKey: '52747' },
    { name: 'Anwar hossain', privateKey: '134822' },
    { name: 'Mohi Uddin', privateKey: '16887' },
    { name: 'Noor N Hossain', privateKey: '002282' },
    { name: 'Rehana Begum', privateKey: '142655' },
    { name: 'shohel ahmed', privateKey: '671852' },
    { name: 'M A Basher', privateKey: '545772' },
    { name: 'Dilruba Quazi', privateKey: '126677' },
    { name: 'Shah Badruzzaman', privateKey: '331922' },
    { name: 'Mohammed Hossain', privateKey: '539776' },
    { name: 'MD UJJWAL SAYAL', privateKey: '14131' },
    { name: 'Nurul islam', privateKey: '571933' },
    { name: 'Mohammad Mujibur Rahman', privateKey: '629949' },
    { name: 'Nurul Momin', privateKey: '141201' },
    { name: 'LITON Chowdhury', privateKey: '421396' },
    { name: 'Mohammad Zunaid', privateKey: '337298' },
    { name: 'Faiyaz Ahmed', privateKey: '443637' },
    { name: 'Mohammad', privateKey: '507675' },
    { name: 'Abdul Howlader', privateKey: '473673' },
    { name: 'Md Borhan Uddin', privateKey: '291528' },
    { name: 'Yasminal', privateKey: '097533' },
    { name: 'Aryan', privateKey: '871024' },
    { name: 'Shahin Ahmed', privateKey: '852350' },
    { name: 'Md shamim khan', privateKey: '313383' },
    { name: 'Jesmin Chowdhury', privateKey: '964399' },
    { name: 'Mafoja islam', privateKey: '234662' },
    { name: 'Mohammed Alam', privateKey: '444346' },
    { name: 'Main uddin', privateKey: '020133' },
    { name: 'Habibur Rahman', privateKey: '283191' },
    { name: 'Mm Romzan Ali', privateKey: '295647' },
    { name: 'Syed Hossain', privateKey: '764347' },
    { name: 'Fatima Mukta', privateKey: '009461' },
    { name: 'Sharder Shirajul Islam', privateKey: '011602' },
    { name: 'Jashim', privateKey: '65889' },
    { name: 'Jasmine Begum', privateKey: '000449' },
    { name: 'Md Mofiz Uddin', privateKey: '475721' },
    { name: 'Monika mahbub', privateKey: '676255' },
    { name: 'Anayet Hossain', privateKey: '475235' },
    { name: 'Kamrun Nessa', privateKey: '504207' },
    { name: 'Rafik ullah', privateKey: '889935' },
    { name: 'Md. Shamsul Islam', privateKey: '7883' },
    { name: 'DALIA SARWAR', privateKey: '247222' },
    { name: 'Mahmudul', privateKey: '406596' },
    { name: 'Lutfoun Naher', privateKey: '518917' },
    { name: 'Md Khairul Alam', privateKey: '817535' },
    { name: 'Md jikrul hasan', privateKey: '658381' },
    { name: 'Ibrahim bin Hashem', privateKey: '413477' },
    { name: 'Md Abul Hashem', privateKey: '693735' },
    { name: 'Tofael ahamed', privateKey: '752610' },
    { name: 'MOHAMMAD N GONY', privateKey: '357194' },
    { name: 'Md Mamunor Rashid', privateKey: '696039' },
    { name: 'Mkarim', privateKey: '888888' },
    { name: 'Esmat jahan', privateKey: '563271' },
    { name: 'Lina khan', privateKey: '830101' },
    { name: 'Tania Rahman', privateKey: '796032' },
    { name: 'Mohammad Zillur Rahman', privateKey: '996385' },
    { name: 'Mohammed mahiraj', privateKey: '694666' },
    { name: 'MD A WODUD', privateKey: '932152' },
    { name: 'Yousuf Rahim', privateKey: '004484' },
    { name: 'Hm sayed ahmed', privateKey: '457786' },
    { name: 'Jashim Uddin', privateKey: '255798' },
    { name: 'Md Abul Hashem', privateKey: '693735' },
    { name: 'Abdullah Al Mamun', privateKey: '854494' },
    { name: 'Mohammad Romzan Ali', privateKey: '962643' },
    { name: 'Md. Sayem Miah', privateKey: '818443' },
    { name: 'Mohammad Rafiqul islam', privateKey: '607391' },
    { name: 'Md razzak', privateKey: '792598' },
    { name: 'Nivana jahan', privateKey: '4655' },
    { name: 'M Sarwar', privateKey: '936442' },
    { name: 'Naznin Fancy', privateKey: '144349' },
    { name: 'Mahmud Mishu', privateKey: '366194' },
    { name: 'Anna asha', privateKey: '151610' },
    { name: 'Miluara Begum', privateKey: '694666' },
    { name: 'Hasin Ishrak', privateKey: '943250' },
    { name: 'Munna Ahmed', privateKey: '82192' },
    { name: 'MIR Layzu Siddiqua', privateKey: '989080' },
    { name: 'Bahar Chowdhury', privateKey: '674638' },
    { name: 'Arif', privateKey: '406189' },
    { name: 'Dulal uddin', privateKey: '661533' },
    { name: 'Marzabin subhan', privateKey: '575831' },
    { name: 'Md Amirul Islam', privateKey: '492486' },
    { name: 'Farida khan', privateKey: '026414' },
    { name: 'Nayeem Hossain', privateKey: '995839' },
    { name: 'Mohammad Dakua', privateKey: '963146' },
    { name: 'Nasrin Jahan', privateKey: '362641' },
    { name: 'Md Anom', privateKey: '004069' },
    { name: 'Bashir ahmed', privateKey: '333998' },
    { name: 'Raju Rahman', privateKey: '357170' },
    { name: 'Nurul Raihan', privateKey: '038471' },
    { name: 'Mohammed Rashiduzzaman', privateKey: '174629' },
    { name: 'Tasnim Maisha', privateKey: '526587' },
    { name: 'Shahera Khatun', privateKey: '653421' },
    { name: 'Mohammed Shamsuddin', privateKey: '949043' },
    { name: 'Mathias Rozario', privateKey: '417311' },
    { name: 'Sunita Aryal', privateKey: '333607' },
    { name: 'Mohammed A Patwary', privateKey: '039000' },
    { name: 'Shirin A Rakhi', privateKey: '474146' },
    { name: 'Mozammel hoque', privateKey: '573433' },
    { name: 'MdKhan', privateKey: '327262' },
    { name: 'Nurul Raihan', privateKey: '038471' },
    { name: 'Udoy Bhattacharjee', privateKey: '995177' },
    { name: 'Mohammad J. Kabir', privateKey: '890574' },
    { name: 'Nasren Akhter', privateKey: '123012' },
    { name: 'Sayed M', privateKey: '167060' },
    { name: 'Tazmina Akter', privateKey: '440549' },
    { name: 'Kazi Islam', privateKey: '453814' },
    { name: 'Mohammed Jamil', privateKey: '598756' },
    { name: 'Sankar Biswas', privateKey: '436854' },
    { name: 'Ashraful Hoque', privateKey: '39191' },
    { name: 'Mohammed', privateKey: '039000' },
    { name: 'Roksana Begum', privateKey: '397534' },
    { name: 'Md shahadat Hossain', privateKey: '227647' },
    { name: 'Seakh Alim', privateKey: '374518' },
    { name: 'Kaniz Fatima', privateKey: '533847' },
    { name: 'Yamin Nuchaery', privateKey: '125712' },
    { name: 'S M Sayeed Mahmood', privateKey: '188572' },
    { name: 'Najmun Begum', privateKey: '950058' },
    { name: 'Md Rahman', privateKey: '560068' },
    { name: 'Mehbuba Islam', privateKey: '528216' },
    { name: 'Syeda Yeasmin', privateKey: '746871' },
    { name: 'Shikha Elias', privateKey: '983669' },
    { name: 'MD M HOSSAIN', privateKey: '315408' },
    { name: 'Mohammed Abdul Mannan', privateKey: '058480' },
    { name: 'Mohammad Roman Sarker', privateKey: '569828' },
    { name: 'Md Iqbal Hossain', privateKey: '213131' },
    { name: 'Subrat Aryal', privateKey: '406421' },
    { name: 'Abu Rahaman', privateKey: '680954' },
    { name: 'Helali Mallik', privateKey: '303349' },
    { name: 'Mohammad M Ahammad', privateKey: '566341' },
    { name: 'ASMA akter', privateKey: '566341' },
    { name: 'Safaeth', privateKey: '7772827' },
     { name: 'mojib', privateKey: '000000' },
    { name: 'mahadi', privateKey: '445541' }
  ];

  // State variables
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [keyInput, setKeyInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [sessionExpiration, setSessionExpiration] = useState(null);
  const [remainingTime, setRemainingTime] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [pageImage, setPageImage] = useState('');
  const [isSessionWarning, setIsSessionWarning] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [isReviewsModalOpen, setIsReviewsModalOpen] = useState(false);
  const [reviewText, setReviewText] = useState('');
  const [userName, setUserName] = useState('');
  const [loginMessage, setLoginMessage] = useState('');
  const [reviews, setReviews] = useState([]);
  const [hasReviewed, setHasReviewed] = useState(false);

  // Array of image URLs for the book using the new file names
  const pages = [
    'https://ik.imagekit.io/h0lbbzcj0/Root%20to%20cure%20book%20-%20page/root%20to%20cure%20book%20page%20(1)_S6pY-HdkQ7.jpg?updatedAt=1754048653893',
    ...Array.from({ length: totalPages - 1 }, (_, i) => `/images/roottocurebookpage${i + 2}.jpg`)
  ];

  // Effect to handle initial state, dark mode, and session persistence
  useEffect(() => {
    // Check for dark mode preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const storedDarkMode = localStorage.getItem('isDarkMode');
    if (storedDarkMode !== null) {
      setIsDarkMode(storedDarkMode === 'true');
    } else {
      setIsDarkMode(prefersDark);
    }

    // Check for an existing session and last read page
    const storedExpiration = localStorage.getItem('sessionExpiration');
    const storedLastPage = localStorage.getItem('lastReadPage');
    const storedUser = localStorage.getItem('loggedInUser');
    const storedHasReviewed = localStorage.getItem('hasReviewed');

    if (storedExpiration && new Date().getTime() < parseInt(storedExpiration)) {
      setIsLoggedIn(true);
      setSessionExpiration(parseInt(storedExpiration));
      if (storedLastPage) {
        setCurrentPage(parseInt(storedLastPage));
      }
      if (storedUser) {
        setUserName(storedUser);
      }
      if (storedHasReviewed) {
        setHasReviewed(storedHasReviewed === 'true');
      }
    } else {
      // Clear expired session data
      localStorage.removeItem('sessionExpiration');
      localStorage.removeItem('lastReadPage');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('hasReviewed');
    }
    
    // Load reviews from local storage on initial load
    const storedReviews = JSON.parse(localStorage.getItem('bookReviews')) || [];
    setReviews(storedReviews);

    // Simulate a brief loading period
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Effect to manage the session countdown timer
  useEffect(() => {
    if (isLoggedIn && sessionExpiration) {
      const interval = setInterval(() => {
        const now = new Date().getTime();
        const timeRemaining = sessionExpiration - now;
        setRemainingTime(timeRemaining);

        // Show a warning 5 minutes before expiration
        if (timeRemaining > 0 && timeRemaining < 5 * 60 * 1000) {
          setIsSessionWarning(true);
        } else {
          setIsSessionWarning(false);
        }

        // Auto-logout if time is up
        if (timeRemaining <= 0) {
          handleLogout();
        }
      }, 1000); // Update every second

      // Cleanup the interval
      return () => clearInterval(interval);
    }
  }, [isLoggedIn, sessionExpiration]);

  // Effect to update the page image on currentPage change
  useEffect(() => {
    if (isLoggedIn) {
      setIsLoading(true);
      // Simulate image loading with a timeout
      const loadingTimeout = setTimeout(() => {
        setPageImage(pages[currentPage - 1]);
        setIsLoading(false);
      }, 300); // 300ms delay to simulate loading

      // Save the last read page to local storage (bookmarking)
      localStorage.setItem('lastReadPage', currentPage.toString());
      
      return () => clearTimeout(loadingTimeout);
    }
  }, [currentPage, isLoggedIn]);

  // Effect to apply dark mode class to the body
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  // Handles the login process
  const handleLogin = (e) => {
      e.preventDefault();
      const user = usersData.find(u => u.privateKey === keyInput);
      if (user) {
        const expirationTime = new Date().getTime() + sessionDuration;
        localStorage.setItem('sessionExpiration', expirationTime.toString());
        localStorage.setItem('loggedInUser', user.name);
        setSessionExpiration(expirationTime);
        setIsLoggedIn(true);
        setUserName(user.name);
        setKeyInput('');
        setLoginMessage('');
      } else {
        setLoginMessage('Invalid private key. Please try again.');
        setTimeout(() => setLoginMessage(''), 3000);
      }
  };

  // Handles the logout process
  const handleLogout = () => {
    setIsLoggedIn(false);
    setKeyInput('');
    setUserName('');
    setSessionExpiration(null);
    setRemainingTime(0);
    setIsSessionWarning(false);
    localStorage.removeItem('sessionExpiration');
    localStorage.removeItem('loggedInUser');
    // We don't remove hasReviewed so the user isn't prompted again on next login
  };

  // Handles changing pages
  const handlePageChange = (direction) => {
    if (isReviewModalOpen) return; // Prevent page change if review modal is open

    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (direction === 'next' && currentPage < totalPages) {
      // Check if a review is required before moving to the next page
      if (currentPage === 50 && !hasReviewed) { // Review is required at page 50, only if not already done
        setIsReviewModalOpen(true);
      } else {
        setCurrentPage(currentPage + 1);
      }
    }
  };
  
  const handlePageJump = (pageNumber) => {
    if (isReviewModalOpen) return;
    const page = parseInt(pageNumber);
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
       // Check if a review is required before jumping to the next page
      if (page >= 50 && currentPage < 50 && !hasReviewed) {
        setIsReviewModalOpen(true);
      } else {
        setCurrentPage(page);
      }
    }
  };

  // Handles the review submission
  const handleReviewSubmit = (e) => {
    e.preventDefault();
    // Get existing reviews from local storage, or initialize an empty array
    const existingReviews = JSON.parse(localStorage.getItem('bookReviews')) || [];
    
    // Create a new review object with user name
    const newReview = {
      user: userName, // Use the logged-in user's name
      page: currentPage,
      text: reviewText,
      timestamp: new Date().toISOString(),
    };

    // Add the new review to the array
    const updatedReviews = [...existingReviews, newReview];
    setReviews(updatedReviews);
    
    // Save the updated reviews array back to local storage
    localStorage.setItem('bookReviews', JSON.stringify(updatedReviews));
    
    // Mark that the user has reviewed the book
    setHasReviewed(true);
    localStorage.setItem('hasReviewed', 'true');
    
    // Clear review text and close the modal
    setReviewText('');
    setIsReviewModalOpen(false);
    
    // Advance to the next page
    setCurrentPage(currentPage + 1);
  };
  
  // Handles downloading reviews as a JSON file
  const handleDownloadReviews = () => {
    const filename = 'book_reviews.json';
    const jsonStr = JSON.stringify(reviews, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Toggles dark mode
  const toggleDarkMode = () => {
    const newDarkMode = !isDarkMode;
    setIsDarkMode(newDarkMode);
    localStorage.setItem('isDarkMode', newDarkMode.toString());
  };
  
  // Toggles review modal visibility
  const toggleReviewsModal = () => {
    setIsReviewsModalOpen(!isReviewsModalOpen);
  };

  // Format the remaining time for display
  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };
  
  const renderPaginationButtons = () => {
    const pagesToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + pagesToShow - 1);
    const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

    return (
      <>
        {currentPage > 1 && (
          <button
            onClick={() => handlePageChange('prev')}
            className="px-3 py-1 mx-1 rounded-md text-gray-800 dark:text-gray-200 bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600 transition-colors"
            aria-label="Previous Page"
          >
            &lt;
          </button>
        )}
        {pageNumbers.map(page => (
          <button
            key={page}
            onClick={() => handlePageJump(page)}
            className={`px-3 py-1 mx-1 rounded-md transition-all duration-300 ${
              page === currentPage
                ? 'bg-blue-600 text-white font-bold scale-110'
                : 'text-gray-800 dark:text-gray-200 bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600'
            }`}
          >
            {page}
          </button>
        ))}
        {currentPage < totalPages && (
          <button
            onClick={() => handlePageChange('next')}
            className="px-3 py-1 mx-1 rounded-md text-gray-800 dark:text-gray-200 bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600 transition-colors"
            aria-label="Next Page"
          >
            &gt;
          </button>
        )}
      </>
    );
  };
  

  // --- Render logic ---
  return (
    <div className="min-h-screen font-sans bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 transition-colors duration-300 flex flex-col items-center justify-center p-4">
      {/* Header with title and dark mode toggle */}
      <header className="w-full max-w-4xl p-4 flex flex-col sm:flex-row justify-between items-center bg-white dark:bg-gray-800 rounded-lg shadow-md mb-6 transition-all duration-300">
        <div className="text-center sm:text-left mb-4 sm:mb-0">
          <h1 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-green-500">{bookTitle}</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">by {bookAuthor}</p>
          {isLoggedIn && <p className="text-md font-semibold mt-1">Logged in as: {userName}</p>}
        </div>
        <div className="flex items-center space-x-4">
          {isLoggedIn && (
            <div className="text-sm font-medium hidden sm:block">
              Session ends in: <span className="font-mono text-yellow-500">{formatTime(remainingTime)}</span>
            </div>
          )}
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-300 focus:outline-none"
            aria-label="Toggle dark mode"
          >
            {isDarkMode ? <Sun size={20} className="text-yellow-400" /> : <Moon size={20} className="text-blue-600" />}
          </button>
        </div>
      </header>

      {/* Login message toast */}
      {loginMessage && (
        <div className="fixed top-4 right-4 bg-red-500 text-white p-4 rounded-lg shadow-lg z-50 transition-transform duration-300 transform animate-slideInRight">
          <div className="flex items-center space-x-2">
            <XCircle size={20} />
            <span>{loginMessage}</span>
          </div>
        </div>
      )}

      {/* Main content area */}
      <main className="w-full max-w-4xl flex-grow flex flex-col items-center justify-center">
        {!isLoggedIn ? (
          // Login form
          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md w-full max-w-sm transition-all duration-300">
            <h2 className="text-xl font-bold mb-4 text-center">Enter Private Key to Access</h2>
            <p className="text-sm text-center mb-4 text-gray-500 dark:text-gray-400">Your key is the last 6 digits of your phone number.</p>
            <form onSubmit={handleLogin} className="flex flex-col space-y-4">
              <input
                type="text"
                value={keyInput}
                onChange={(e) => setKeyInput(e.target.value)}
                placeholder="Enter your private key"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200"
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Log In
              </button>
            </form>
          </div>
        ) : (
          // Book reader interface
          <div className="w-full h-full flex flex-col items-center justify-center space-y-4">
            {/* Book display area */}
            <div className="flex-shrink-0 w-full max-w-sm md:max-w-xl bg-white dark:bg-gray-800 rounded-lg shadow-xl p-4 flex flex-col items-center transition-all duration-300 relative overflow-hidden">
              <div className="w-full h-full aspect-[2/3] flex items-center justify-center overflow-hidden rounded-md relative">
                {isLoading && (
                  <div className="absolute inset-0 flex items-center justify-center bg-gray-200 dark:bg-gray-700 animate-pulse rounded-md">
                    <Loader size={48} className="animate-spin text-blue-500" />
                  </div>
                )}
                {pageImage && !isLoading && (
                  <img
                    key={currentPage} // Use key to force re-render and trigger transition
                    src={pageImage}
                    alt={`Page ${currentPage}`}
                    className="w-full h-auto rounded-md transition-opacity duration-500 ease-in-out opacity-100 animate-fadeIn"
                    style={{ animationDuration: '0.5s' }}
                    onError={(e) => e.target.src = 'https://placehold.co/1000x1500/A3917C/ffffff?text=Page+Not+Found'}
                  />
                )}
              </div>
              
              {/* Session warning message */}
              {isSessionWarning && (
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 p-2 bg-red-600 text-white text-sm rounded-md shadow-lg transition-opacity duration-300 animate-bounce">
                  Session expiring soon!
                </div>
              )}
            </div>
            
            {/* Pagination controls at the bottom */}
            <div className="w-full flex flex-col items-center mt-4">
              <div className="flex justify-center items-center">
                {renderPaginationButtons()}
              </div>
            </div>
          </div>
        )}
      </main>

      {isLoggedIn && (
        <footer className="w-full max-w-4xl p-4 flex flex-col sm:flex-row justify-between items-center bg-white dark:bg-gray-800 rounded-lg shadow-md mt-6 transition-all duration-300">
          <div className="text-sm font-medium text-gray-600 dark:text-gray-400">
            Current page: {currentPage} of {totalPages}
          </div>
          <div className="text-sm font-medium text-gray-600 dark:text-gray-400 mt-2 sm:mt-0">
             Session ends in: <span className="font-mono text-yellow-500">{formatTime(remainingTime)}</span>
          </div>
          <button
            onClick={toggleReviewsModal}
            className="mt-4 sm:mt-0 px-4 py-2 bg-purple-600 text-white rounded-md font-semibold hover:bg-purple-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            View Reviews
          </button>
          <button
            onClick={handleLogout}
            className="mt-4 sm:mt-0 px-4 py-2 bg-red-600 text-white rounded-md font-semibold hover:bg-red-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Log Out
          </button>
        </footer>
      )}

      {/* Review Modal */}
      {isReviewModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4 animate-fadeIn">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-2xl w-full max-w-md transition-all duration-300 animate-scaleIn">
            <h3 className="text-xl font-bold mb-4">Review Required</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Please write a brief review of the book to continue reading.
            </p>
            <form onSubmit={handleReviewSubmit} className="flex flex-col space-y-4">
              <input
                type="text"
                value={userName}
                placeholder="Enter your name"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200"
                readOnly // Make the input read-only as the name is already populated
              />
              <textarea
                value={reviewText}
                onChange={(e) => setReviewText(e.target.value)}
                placeholder="Write your review here..."
                rows="4"
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 resize-none"
                required
              ></textarea>
              <button
                type="submit"
                disabled={!reviewText.trim()}
                className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold disabled:bg-gray-400 disabled:cursor-not-allowed hover:bg-blue-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Submit Review and Continue
              </button>
            </form>
          </div>
        </div>
      )}
      
      {/* Admin Reviews Modal */}
      {isReviewsModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4 animate-fadeIn">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-2xl w-full max-w-xl max-h-[80vh] overflow-y-auto transition-all duration-300 animate-scaleIn">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold">All Book Reviews</h3>
              <button onClick={toggleReviewsModal} className="p-1 rounded-full text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors">
                <XCircle size={24} />
              </button>
            </div>
            {reviews.length > 0 ? (
              <div className="space-y-4">
                <button
                  onClick={handleDownloadReviews}
                  className="w-full bg-green-600 text-white py-2 rounded-md font-semibold hover:bg-green-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-green-500 flex items-center justify-center space-x-2"
                >
                  <Download size={20} />
                  <span>Download All Reviews</span>
                </button>
                <ul className="space-y-4 mt-4">
                  {reviews.map((review, index) => (
                    <li key={index} className="p-4 rounded-md bg-gray-100 dark:bg-gray-700 shadow">
                      <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                        User: <span className="font-bold text-lg">{review.user || 'Anonymous'}</span>
                      </p>
                      <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                        Review for Page: {review.page}
                      </p>
                      <p className="text-sm italic text-gray-500 dark:text-gray-400 mb-2">
                        Submitted on: {new Date(review.timestamp).toLocaleString()}
                      </p>
                      <p className="text-gray-800 dark:text-gray-200">{review.text}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <p className="text-gray-500 dark:text-gray-400">No reviews have been submitted yet.</p>
            )}
          </div>
        </div>
      )}

      {/* Tailwind CSS keyframes for animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }

        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        .animate-scaleIn {
          animation: scaleIn 0.3s ease-out forwards;
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        .animate-bounce {
          animation: bounce 1s infinite;
        }
        
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slideInRight {
          animation: slideInRight 0.5s ease-out forwards;
        }
      `}</style>
    </div>
  );
}
